/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ReportsInputs */

const en_reports = /** @type {(inputs: ReportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reports`)
};

const id_reports = /** @type {(inputs: ReportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporan`)
};

/** @type {(inputs: ReportsInputs) => LocalizedString} */
const es_reports = en_reports;

/** @type {(inputs: ReportsInputs) => LocalizedString} */
const fr_reports = en_reports;

/** @type {(inputs: ReportsInputs) => LocalizedString} */
const de_reports = en_reports;

/** @type {(inputs: ReportsInputs) => LocalizedString} */
const ja_reports = en_reports;

/** @type {(inputs: ReportsInputs) => LocalizedString} */
const zh_reports = en_reports;

/** @type {(inputs: ReportsInputs) => LocalizedString} */
const ar_reports = en_reports;

/** @type {(inputs: ReportsInputs) => LocalizedString} */
const it_reports = en_reports;

/** @type {(inputs: ReportsInputs) => LocalizedString} */
const ru_reports = en_reports;

/** @type {(inputs: ReportsInputs) => LocalizedString} */
const pt_reports = en_reports;

/** @type {(inputs: ReportsInputs) => LocalizedString} */
const ko_reports = en_reports;

/**
* | output |
* | --- |
* | "Reports" |
*
* @param {ReportsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reports = /** @type {((inputs?: ReportsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ReportsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports(inputs)
	if (locale === "es") return es_reports(inputs)
	if (locale === "fr") return fr_reports(inputs)
	if (locale === "de") return de_reports(inputs)
	if (locale === "ja") return ja_reports(inputs)
	if (locale === "zh") return zh_reports(inputs)
	if (locale === "ar") return ar_reports(inputs)
	if (locale === "id") return id_reports(inputs)
	if (locale === "it") return it_reports(inputs)
	if (locale === "ru") return ru_reports(inputs)
	if (locale === "pt") return pt_reports(inputs)
	return ko_reports(inputs)
});